import useExercisesStatus from "providers/ExercisesProvider/useExercisesStatus";
import useFeatureFlagStatus from "providers/FeatureFlagProvider/useFeatureFlagStatus";
import useWellnessMetadataStatus from "providers/WellnessMetadataProvider/useWellnessMetadataStatus";
import { useMemo } from "react";

function useDataProviderStatus() {
  const featureFlagStatus = useFeatureFlagStatus();
  const exercisesStatus = useExercisesStatus();
  const wellnessStatus = useWellnessMetadataStatus();

  return useMemo(() => {
    const statuses = [featureFlagStatus, exercisesStatus, wellnessStatus];
    if (statuses.some((s) => s === "fetching")) return "fetching";
    if (statuses.some((s) => s === "error")) return "error";
    return "success";
  }, [featureFlagStatus, exercisesStatus, wellnessStatus]);
}

export default useDataProviderStatus;
